import OptInModalWrapper from './OptInModalWrapper';

export default OptInModalWrapper;
